module.exports = __webpack_public_path__ + "static/media/sourcesanspro-regular-webfont.d2e3cf3e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/sourcesanspro-regular-webfont.woff
// module id = 272
// module chunks = 0